

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// getAllHomeSections
// GETALLHOMESECTIONS
const GETALLHOMESECTIONS= createAsyncThunk(
  "getAllHomeSections/getAllHomeSections",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllHomeSectionsSlice = createSlice({
  name: "getAllHomeSectionsSlice",
  initialState: {
    PublishPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GETALLHOMESECTIONS.fulfilled, (state, action) => {
      state.getAllHomeSections = {
        ...state.getAllHomeSections,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLHOMESECTIONS.pending, (state, action) => {
      state.getAllHomeSections = {
        ...state.getAllHomeSections,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLHOMESECTIONS.rejected, (state, action) => {
      state.getAllHomeSections = {
        ...state.getAllHomeSections,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllHomeSectionsAction = {
  GETALLHOMESECTIONS,
};

export { getAllHomeSectionsAction };
export default getAllHomeSectionsSlice.reducer;
